<template>
  <div class="container">
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.productOrderNo') + ':'" prop="productOrderNo">
        <el-input
          v-model.trim="form.productOrderNo"
          name="incoOrderNo"
          type="text"
          autocomplete="on"
          clearable
          tabindex="1"
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.customerName') + ':'" prop="customerId">
        <el-select
          v-model="form.customerId"
          clearable
          filterable
          size="small"
          style="width: 200px;">
          <el-option
            v-for="item in customersList"
            :key="item.id"
            :label="item.customerName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.orderTime') + ':'" prop="orderDate">
        <el-date-picker
          v-model="form.orderDate"
          type="daterange"
          size="small"
          clearable
          style="width: 250px;"
          :picker-options="pickerOptions"
          :default-value="defaultTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.status') + ':'" prop="status">
        <el-select
          v-model="form.status"
          clearable
          filterable
          style="width: 150px;"
          size="small">
          <el-option
            v-for="(item, key) in prodOrderStatus"
            :key="key"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button type="primary" size="small" @click="queryOrderRecord">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="separator"></div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        :span-method="objectSpanMethod">
        <el-table-column prop="productOrderNo" :label="$t('common.productOrderNo')"/>
        <el-table-column :label="$t('common.customerName')">
          <template slot-scope="scope">
            {{scope.row.customer && scope.row.customer.customerName}}
          </template>
        </el-table-column>
        <el-table-column prop="prodInfo" label="产品型号"/>
        <el-table-column prop="count" label="数量"/>
        <el-table-column prop="allCount" label="总数量"/>
        <el-table-column :label="$t('deliveryGoods.requestExpress')">
          <template slot-scope="scope">
            {{expressageVal(scope.row.expressage)}}
          </template>
        </el-table-column>
        <el-table-column prop="expressageType" :label="$t('common.expressageType')">
          <template slot-scope="scope">
            {{expressageTypeVal(scope.row.expressageType)}}
          </template>
        </el-table-column>
        <el-table-column prop="expressageNo" :label="$t('common.expressageNo')"/>
        <el-table-column prop="contactAddr" :label="$t('common.address')"/>
        <el-table-column prop="contact" :label="$t('common.contact')"/>
        <el-table-column prop="contactPhone" :label="$t('common.contactPhone')"/>
        <el-table-column :label="$t('common.orderTime')" width="150">
          <template slot-scope="scope">
            {{formatDate(scope.row.createAt)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.status')">
          <template slot-scope="scope">
            {{prodOrderStatusVal(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="link"
              @click="deleteProductOrder(scope.row)"
              :disabled="disableDeleteProductOrder(scope.row)"
              :class="{'is-disabled': disableDeleteProductOrder(scope.row)}">
              {{$t('common.delete')}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.detail')">
          <template slot-scope="scope">
            <router-link :to="'/tpProd-order-detail/edit/' + scope.row.productOrderNo">
              <el-button type="text" class="link" >
                {{$t('common.detail')}}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { prodOrderStatus, expressages, expressageTypes } from '@/utils/defines';
import { tporderList, tporderDelete } from '@/api/tpProdOrder';
import { customersList } from '@/api/customers';
import { isValueEmpty } from "@/utils";
import {
  Pagination,
} from '@/components';

const defaultForm = {
  productOrderNo: undefined,
  customerId: undefined,
  lotNo: undefined,
  orderDate: undefined,
  status: undefined,
};

export default {
  name: 'TpProdHistory',
  components: {
    Pagination,
  },
  data() {
    const prodOrderStatusObj = {};
    let prodOrderStatueItem;
    for (const key in prodOrderStatus) {
      if (Object.prototype.hasOwnProperty.call(prodOrderStatus, key)) {
        prodOrderStatueItem = prodOrderStatus[key];
        prodOrderStatusObj[prodOrderStatueItem.val] = prodOrderStatueItem.prodOderExplain || prodOrderStatueItem.explain;
      }
    }
    const expressagesObj = {};
    let expressagesItem;
    for (const key in expressages) {
      if (Object.prototype.hasOwnProperty.call(expressages, key)) {
        expressagesItem = expressages[key];
        expressagesObj[expressagesItem.val] = expressagesItem.explain;
      }
    }
    const expressageTypesObj = {};
    let expressageTypesItem;
    for (const key in expressageTypes) {
      if (Object.prototype.hasOwnProperty.call(expressageTypes, key)) {
        expressageTypesItem = expressageTypes[key];
        expressageTypesObj[expressageTypesItem.val] = expressageTypesItem.explain;
      }
    }
    return {
      form: Object.assign({}, defaultForm),
      searchParams: Object.assign({}, defaultForm),
      rules: {

      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      customersList: [],
      prodOrderStatus,
      prodOrderStatusObj,
      expressagesObj,
      expressageTypesObj,
    };
  },
  computed: {
    displayData() {
      return this.listData;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > moment().add(1, 'days').valueOf();
        }
      };
    },
    defaultTime() {
      return moment().subtract(1, 'months').valueOf();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.tporderList();
    })
  },
  mounted() {
    this.customersListGet(1, 200);
  },
  methods: {
    onChangePage() {
      this.tporderList();
    },
    async tporderList() {
      try {
        const {
          productOrderNo,
          customerId,
          lotNo,
          orderDate,
          status,
        } = this.searchParams;
        let orderStartDate;
        let orderEndDate;
        if (orderDate && orderDate.length === 2) {
          [orderStartDate, orderEndDate] = orderDate;
        }
        const res = await tporderList({
          page: this.page,
          perpage: this.perpage,
          productOrderNo: productOrderNo || undefined,
          customerId: customerId || undefined,
          lotNo: lotNo || undefined,
          orderStartDate,
          orderEndDate,
          status: isValueEmpty(status) ? undefined : status,
        });
       const { data } = res;
       if (data.count !== undefined) {
         this.totalCount = data.count;
       }
       this.listData = [];
       let prodInfos, length ,allCount = 0;
       data.records.map(item => {
         prodInfos = item.prodInfos;
         length = prodInfos.length;
         allCount = 0;
         for(let prodInfo of prodInfos){
           allCount = allCount + prodInfo.count;
         }
         for (let i = 0; i < length; i++) {
           if (i === 0) {
             this.listData.push({
               ...item,
               ...prodInfos[i],
               allCount: allCount,
               rowspan: length,
             });
           } else {
             this.listData.push({
               ...item,
               ...prodInfos[i],
               allCount: allCount,
               rowspan: 0,
             });
           }
         }
       });

      } catch (e) {
        // do nothing.
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.tporderList();
    },
    queryOrderRecord() {
      this.page = 1;
      this.searchParams = {...this.form};
      this.tporderList();
    },
    prodOrderStatusVal(val) {
      return this.prodOrderStatusObj[`${val}`];
    },
    expressageVal(val) {
      return this.expressagesObj[`${val}`];
    },
    expressageTypeVal(val) {
      return this.expressageTypesObj[`${val}`];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
    binLevelDataVal(binLevelData) {
      if (binLevelData && binLevelData.length > 0) {
        return binLevelData.join('、');
      }
      return '';
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 2 && columnIndex !== 3) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
    deleteProductOrder(row) {
      this.$confirm(this.$t('deliveryGoods.thisActionWillDeleteTheDeliveryOrder'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        try {
          await tporderDelete({ productOrderNo: row.productOrderNo });
          this.tporderList();
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });
    },
    disableDeleteProductOrder(row) {
      const {
        status
      } = row;
      return status === prodOrderStatus.send.val || status === prodOrderStatus.finished.val;
    }
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }
  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 20px 20px 0;
    height: 100%;
    overflow: auto;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .link.is-disabled {
    color: #C0C4CC;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
